export const PLUGINS = [
  {
    name: "BlueMap",
    short: "Online-Karte",
    url: "https://www.spigotmc.org/resources/bluemap.83557/",
    interestingForUser: false,
  },
  {
    name: "Citizens",
    short: "NPCs",
    url: "https://www.spigotmc.org/resources/citizens.13811/",
    interestingForUser: false,
  },
  {
    name: "DiscordSRV",
    short: "Discord Integration",
    url: "https://www.spigotmc.org/resources/discordsrv.18494/",
    interestingForUser: true,
  },
  {
    name: "EssentialsX",
    short: "Essentials",
    url: "https://essentialsx.net/downloads.html",
    interestingForUser: false,
  },
  {
    name: "EssentialsX Chat",
    short: "Essentials for Chat",
    url: "https://essentialsx.net/downloads.html",
    interestingForUser: false,
  },
  {
    name: "EssentialsX Spawn",
    short: "Essentials for Spawn",
    url: "https://essentialsx.net/downloads.html",
    interestingForUser: false,
  },
  {
    name: "Floodgate",
    short: "Bedrock on Java-Server",
    url: "https://geysermc.org/download?project=floodgate",
    interestingForUser: false,
  },
  {
    name: "GeyserMC",
    short: "Bedrock on Java-Server",
    url: "https://geysermc.org/download",
    interestingForUser: false,
  },
  {
    name: "Graves",
    short: "Grabsteine & Death-drops",
    url: "https://github.com/AvarionMC/graves/releases",
    interestingForUser: true,
  },
  {
    name: "HSRails",
    short: "Faster Rails",
    url: "https://www.spigotmc.org/resources/hsrails.69584/",
    interestingForUser: true,
  },
  {
    name: "ImageOnMap",
    short: "Images on Map",
    url: "https://www.spigotmc.org/resources/imageonmap.26585/",
    interestingForUser: false,
  },
  {
    name: "LuckPerms",
    short: "Permissions",
    url: "https://www.spigotmc.org/resources/luckperms.28140/",
    interestingForUser: false,
  },
  {
    name: "McMMO",
    short: "Skill- & Level-System",
    url: "https://www.spigotmc.org/resources/official-mcmmo-original-author-returns.64348/",
    interestingForUser: true,
  },
  {
    name: "Multiverse Core",
    short: "Mehrwelt-System",
    url: "https://dev.bukkit.org/projects/multiverse-core",
    interestingForUser: false,
  },
  {
    name: "Multiverse NetherPortals",
    short: "Mehrwelt-System (Nether/End)",
    url: "https://dev.bukkit.org/projects/multiverse-netherportals/",
    interestingForUser: false,
  },
  {
    name: "Multiverse Portals",
    short: "Mehrwelt-System (Portale)",
    url: "https://dev.bukkit.org/projects/multiverse-portals/",
    interestingForUser: false,
  },
  {
    name: "ServerTAP",
    short: "Server-API",
    url: "https://github.com/servertap-io/servertap",
    interestingForUser: false,
  },
  {
    name: "ShopGUIPlus",
    short: "Shop via GUI",
    url: "https://www.spigotmc.org/resources/shopgui-1-8-1-21.6515/",
    interestingForUser: true,
  },
  {
    name: "ShopGUIPlus SellGUI",
    short: "Quickly sell items",
    url: "https://www.spigotmc.org/resources/shopguiplus-sellgui.85170/",
    interestingForUser: true,
  },
  {
    name: "Skript",
    short: "Scripting",
    url: "https://www.spigotmc.org/resources/skript.114544/",
    interestingForUser: false,
  },
  {
    name: "Stargate",
    short: "Teleportation",
    url: "https://hangar.papermc.io/Stargate/Stargate",
    interestingForUser: true,
  },
  {
    name: "TerraformGenerator",
    short: "Landschaften erstellen",
    url: "https://www.spigotmc.org/resources/terraformgenerator-1-18-2-1-21-4.75132/",
    interestingForUser: true,
  },
  {
    name: "The New Economy",
    short: "Economy",
    url: "https://www.spigotmc.org/resources/the-new-economy.7805/",
    interestingForUser: true,
  },
  {
    name: "Vault",
    short: "Economy",
    url: "https://www.spigotmc.org/resources/vault.34315/",
    interestingForUser: false,
  },
  {
    name: "ViaBackwards",
    short: "Older clients on newer server",
    url: "https://hangar.papermc.io/ViaVersion/ViaBackwards/versions",
    interestingForUser: false,
  },
  {
    name: "ViaVersion",
    short: "Newer clients on older server",
    url: "https://hangar.papermc.io/ViaVersion/ViaVersion/versions",
    interestingForUser: false,
  },
  {
    name: "WorldEdit",
    short: "World-Editing",
    url: "https://dev.bukkit.org/projects/worldedit",
    interestingForUser: false,
  },
  {
    name: "WorldEdit Selection Visualizer",
    short: "World-Editing",
    url: "https://www.spigotmc.org/resources/worldeditselectionvisualizer-1-7-10-1-21.17311/",
    interestingForUser: false,
  },
  {
    name: "WorldGuard",
    short: "World-Editing",
    url: "https://dev.bukkit.org/projects/worldguard",
    interestingForUser: false,
  },
  {
    name: "Zero Inventory Problems Zip Backpacks",
    short: "Backpacks",
    url: "https://www.spigotmc.org/resources/zero-inventory-problems-zip-backpacks.107552/",
    interestingForUser: true,
  },
] as const
